import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { X, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetClose } from '@/components/ui/sheet';

interface WizardHelpPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  step: number;
}

const helpContent: Record<number, { title: string; content: React.ReactNode }> = {
  1: {
    get title() { return translateInterfaceText("Informações Básicas"); },
    content: (
      <>
        <p className="text-sm text-muted-foreground mb-4">
          {translateInterfaceText("Configure as informações essenciais do seu webinário.")}</p>
        <div className="space-y-4">
          <div>
            <h4 className="font-medium mb-1">{translateInterfaceText("Nome do Webinário")}</h4>
            <p className="text-sm text-muted-foreground">
              {translateInterfaceText("Nome interno para identificação. Não será exibido ao público.")}</p>
          </div>
          <div>
            <h4 className="font-medium mb-1">{translateInterfaceText("Título Público")}</h4>
            <p className="text-sm text-muted-foreground">
              {translateInterfaceText("Título que será exibido na sala para os participantes.")}</p>
          </div>
          <div>
            <h4 className="font-medium mb-1">{translateInterfaceText("URL Amigável")}</h4>
            <p className="text-sm text-muted-foreground">
              {translateInterfaceText("Link único para acessar seu webinário. Exemplo: /w/meu-webinar")}</p>
          </div>
          <div>
            <h4 className="font-medium mb-1">{translateInterfaceText("Acesso Facilitado")}</h4>
            <p className="text-sm text-muted-foreground">
              {translateInterfaceText("Permite que visitantes entrem direto na sala sem fazer login. Útil para maximizar acessos, mas reduz a captação de leads.")}</p>
          </div>
          <div>
            <h4 className="font-medium mb-1">{translateInterfaceText("Sincronizar com Horário")}</h4>
            <p className="text-sm text-muted-foreground">
              {translateInterfaceText("O vídeo começará exatamente no horário agendado. Participantes que entrarem depois verão o vídeo já em andamento.")}</p>
          </div>
        </div>
      </>
    ),
  },
  // Add more steps as needed
};

export function WizardHelpPanel({ open, onOpenChange, step }: WizardHelpPanelProps) {
  useLanguage();
  const content = helpContent[step] || {
    title: translateInterfaceText("Ajuda"),
    content: <p className="text-sm text-muted-foreground">{translateInterfaceText("Informações de ajuda não disponíveis para esta etapa.")}</p>,
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-[400px] sm:w-[540px]">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <HelpCircle className="h-5 w-5 text-primary" />
            {content.title}
          </SheetTitle>
        </SheetHeader>
        <div className="mt-6">
          {content.content}
        </div>
      </SheetContent>
    </Sheet>
  );
}
